export default "__VITE_ASSET__BBPzYbjG__"